<template>
  <div class="container">
    <content-header :data="[{text:'客户一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
            <el-input
              placeholder="客户/手机号/门店"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            fixed
            prop="id"
            label="客户ID"
            width="100">
          </el-table-column>
          <el-table-column
            fixed
            prop="nickName"
            label="客户"
            width="150">
          </el-table-column>
          <el-table-column
            fixed
            prop="shopName"
            label="门店"
            width="150">
          </el-table-column>
          <el-table-column
            label="地区">
            <template slot-scope="scope">
              <span>{{scope.row.provinceName ? scope.row.provinceName+"/"+scope.row.cityName+"/"+scope.row.districtName : ''}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="phoneNumber"
            label="手机号">
          </el-table-column>
          <el-table-column
            prop="created"
            label="创建时间"
            width="180">
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > curSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="curSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import CustomerModel from 'models/customer'

  export default {
    data () {
      return {
        keywords: '',
        tableData: [],
        curPage: 1,
        curSize: 10,
        total: 0,
      }
    },
    created () {
      this.getObjList()
    },
    methods: {
      pageSizeChange (size) {
        this.curSize = size
        this.getObjList({'keywords': this.keywords})
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList({'keywords': this.keywords})
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.curSize
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        CustomerModel.find(_opts).then(res => {
          this.tableData = res.rows
          this.total = res.total
        })
      },
      searchHandle () {
        this.getObjList({'keywords': this.keywords})
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 20px
        span
          display: inline-block
          vertical-align: top
          line-height: 36px
        .entry-box
          display: inline-block
          vertical-align: top
          width: 140px
          &.username
            width: 140px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
      .check-title
        text-align: right
        display: inline-block
        vertical-align: middle
        width: 90px
        font-size: 14px
        color: #48576a
        line-height: 1
        padding: 11px 12px 11px 0
        box-sizing: border-box
</style>



// WEBPACK FOOTER //
// src/views/Customer.vue